export const getFileNameFromContentDisposition = (
  contentDispositionHeader: string,
): string => {
  const fileName = contentDispositionHeader
    .split(";")
    .find((n) => n.includes("filename="))
    ?.replace("filename=", "")
    .replace(/"/g, "")
    .trim();

  return fileName ? fileName : "";
};
